export const activityFeedTitle = "b$R3N";
export default {activityFeedTitle};